import {
  Box,
  Button,
  Td,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CreateTable from "../components/common/Table/Table";
import Loading from "../components/common/ui/Loading";
import { useNavigator } from "../hooks/useNavigator";
import { getMovieLikes } from "../utils/api";

const MovieLikes = () => {
  const { id } = useParams();
  const toast = useToast();
  const nav = useNavigate();
  const [likes, setLikes] = useState([]);
  const [bonusVotes, setBonusVotes] = useState(0);
  const [totalVotes, setTotalVotes] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchLikes = async () => {
    setLoading(true);
    const [success, data] = await getMovieLikes(id);
    if (success) {
      const likesList = Array.isArray(data) ? data : data?.likes || [];
      setLikes(likesList);
      setBonusVotes(data?.bonusVotes || 0);
      setTotalVotes(
        data?.totalVotes ?? likesList.length + (data?.bonusVotes || 0)
      );
    } else {
      toast({
        title: "Error",
        description: "Failed to fetch likes",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  const [navigate, user] = useNavigator(() => {
    if (user) {
      fetchLikes();
    } else {
      navigate("/login");
    }
  });

  if (loading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        gap: "1rem",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Text fontSize="xl" fontWeight="bold">
          Movie Votes {totalVotes ? `(${totalVotes})` : ""}
        </Text>
        <Button colorScheme="gray" onClick={() => nav("/movies")}>
          Back to Movies
        </Button>
      </Box>

      {bonusVotes > 0 && (
        <Text fontSize="sm" color="gray.600">
          {likes.length} user votes + {bonusVotes} admin votes
        </Text>
      )}

      {likes && likes.length > 0 ? (
        <CreateTable
          data={likes}
          searchby={["name", "email", "phone"]}
          pagging={true}
          head={["Name", "Email", "Phone", "Date"]}
          rows={(row) => {
            return (
              <>
                <Td>{row.name || row.user?.name || "N/A"}</Td>
                <Td>{row.email || row.user?.email || "N/A"}</Td>
                <Td>{row.phoneNumber || row.user?.phone || "N/A"}</Td>
                <Td>
                  {row.createdAt
                    ? new Date(row.createdAt).toLocaleDateString()
                    : "N/A"}
                </Td>
              </>
            );
          }}
        />
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Text fontSize="lg" color="gray.600">
            {bonusVotes > 0
              ? "No user votes yet. Admin votes are included in the total."
              : "No Votes at the moment."}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default MovieLikes;
